<template>
  <div class="mod-joylearning__offringlist}">
    <div class="pkg-search-box">
      <el-form class="pkg-content course-ability-form" label-width="auto"
               label-position="left"
               :model="dataForm"
               @keyup.enter.native="getDataList()">
        <el-row class="margb10">
          <el-col :span="7">
            <el-form-item label="职位">
              <el-select v-model="dataForm.jobId"
                         clearable
                         :placeholder="$t('user.select')">
                <el-option v-for="(item,index) in keyPositionArr"
                           :key="index"
                           :label="item.positionCode + '-' +item.positionName"
                           :value="item.positionId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="能力项">
              <el-select v-model="dataForm.parentId"  clearable placeholder="请选择" @change="parentAllChange">
                <el-option
                        v-for="item in parentALl"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7" class="form-right">
            <el-form-item label="子能力项" >
              <el-select v-model="dataForm.childId" clearable placeholder="请选择">
                <el-option
                        v-for="item in parentChildALl"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-col :span="24">
              <el-button class="M-search"
                         style="margin-bottom: 7px"
                         type="primary"
                         @click="getDataListMerge">{{$t('course.query')}}
              </el-button>
            </el-col>
          </el-col>
        </el-row>
        <!-- ---->
        <el-row class="margb10">
          <el-col :span="7">
            <el-form-item label="必修"
                          prop="courseCode" >
              <el-select v-model="dataForm.required" clearable placeholder="请选择">
                <el-option
                        v-for="item in required"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="课程" >
              <el-input v-model="dataForm.courseCodeName" clearable placeholder="输入课程名称或课程代码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" class="form-right">
            <el-form-item label="重要项"
                          prop="importance" >
              <el-select v-model="dataForm.importance" clearable placeholder="请选择">
                <el-option
                    v-for="item in importantList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <!-- 重置 -->
            <el-col :span="24">
              <el-button class="el-back M-search M-margin-l"
                         type="info"
                         @click="again">{{$t('reset')}}
              </el-button>
            </el-col>
          </el-col>
        </el-row>
        <el-row class="margb10">
          <el-col :span="7">
            <el-form-item label="评测分数是否影响"
                          prop="effects" >
              <el-select v-model="dataForm.isAffects" clearable placeholder="请选择">
                <el-option
                    v-for="item in effectsList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row style="text-align: center; margin-bottom: 10px;">
        <el-col :span="24">
          <div class="show-or-hide-icon">
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="pkg-content">
      <div class="search">
        <!-- 新增 btnAdded -->
        <el-button type="primary"
                   @click="addCourseAbility">{{ $t('add') }}
        </el-button>
      </div>
      <!-- 表头动态展示 -->
      <el-table v-loading="dataListLoading"
                ref="multipleTable"
                :data="dataList"
                border
                :row-style="{height:48+'px'}"
                :cell-style="{padding:0+'px'}">


        <!--  职位  -->
        <el-table-column prop="jobName"
                         label="职位"
                         header-align="center"
                         align="center"
                         width="110"
                         :show-overflow-tooltip="true"
                         fixed></el-table-column>
        <!--能力项-->
        <el-table-column prop="parentName"
                         label="能力项"
                         header-align="center"
                         align="left"
                         :show-overflow-tooltip="true"
                         width="110"
                         fixed></el-table-column>

        <!--能力子项-->
        <el-table-column label="子能力项"
                         prop="childName"
                         header-align="left"
                         align="left"
                         :show-overflow-tooltip="true"
                         width="100"></el-table-column>
        <!-- 课程代码 -->
        <el-table-column prop="courseCode"
                         label="课程代码"
                         header-align="left"
                         align="left"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <!-- 课程中文名称 -->
        <el-table-column prop="courseName"
                         label="课程中文名称"
                         header-align="center"
                         align="center"
                         width="145"
                         :show-overflow-tooltip="true"
        ></el-table-column>
        <!-- 学习对象类型 -->
        <el-table-column prop="subTypeName"
                         label="学习对象类型"
                         header-align="center"
                         width="120"
                         :show-overflow-tooltip="true"
                         align="center"></el-table-column>
        <!-- 必修 -->
        <el-table-column prop="requiredName"
                         label="必修"
                         header-align="center"
                         width="80"
                         :show-overflow-tooltip="true"
                         align="center"></el-table-column>
        <!-- 是否重要项 -->
        <el-table-column prop="importance"
                         label="重要项标识"
                         header-align="center"
                         width="100"
                         :show-overflow-tooltip="true"
                         align="center">
          <template slot-scope="scope">
            {{ scope.row.importance === '1' ?  '是':'否' }}
          </template>
        </el-table-column>
        <!-- 是否影响 -->
        <el-table-column prop="isAffects"
                         label="评测分数是否影响标识"
                         header-align="center"
                         width="170"
                         :show-overflow-tooltip="true"
                         align="center">
          <template slot-scope="scope">
            {{ scope.row.isAffects === '1' ?  '是':'否' }}
          </template>
        </el-table-column>
        <!-- 创建时间 -->
        <el-table-column prop="createTime"
                         label="创建时间"
                         header-align="left"
                         align="left"
                         width="140"
                         :show-overflow-tooltip="true"
        ></el-table-column>
        <!-- 最后修改时间 -->
        <el-table-column prop="updateTime"
                         label="最后修改时间"
                         header-align="left"
                         align="left"
                         width="140"
                         :show-overflow-tooltip="true"
        ></el-table-column>
        <!--操作 -->
        <el-table-column :label="$t('offering.operation')"
                         fixed="right"
                         header-align="center"
                         align="center"
                         width="150">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="sendAbilityEdit(scope.row)">编辑</el-link>
            <div class="pkg-vertical-divider"></div>
            <el-link type="primary" :underline="false" @click="deleteAbility(scope.row)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page="page"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="limit"
                     :total="total"
                     layout="total, sizes, prev, pager, next, jumper"
                     @size-change="pageSizeChangeHandle"
                     @current-change="pageCurrentChangeHandle">
      </el-pagination>
    </div>

  </div>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'

export default {
  mixins: [mixinViewModule],
  data() {
    let _this = this
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/actionplan/competencyToCourse/queryCompToCourseList',
        getDataListIsPage: true,
      },
      keyPositionArr:[], // 职位
      parentALl:[], // 能力项
      parentChildALl:[], // 能力子项
      dataForm: {
        // page:1,//页码
        // limit:10,//条数
        jobId:'',//职位id
        parentId:'',//能力项id
        childId:'',//能力子项id
        required:'',//是否必修 0选修 1必修
        courseCodeName:'',//课程查询字段
        importance: '',
        isAffects: ''
      },
      required:[
        {
          value: '1',
          label: '必修'
        }, {
          value: '0',
          label: '选修'
        }
      ],
      importantList: [
        { value: '1', label: '是' },
        { value: '0', label: '否' }
      ],
      effectsList: [
        { value: '1', label: '是' },
        { value: '0', label: '否' }
      ]
    }
  },
  created() {
    this.init()
  },
  methods: {
    // 页面初始化
    init(){
      // 职位
      this.$request
        .get('/sys/commposition/keyPosition', {})
        .then((res, total, code, data) => {
          console.log('kekyPosition')
          console.log(data)
          this.keyPositionArr = data.data
        })
        .catch((err) => {
          console.log(err)
        })
      // 能力项
      this.$request
        .get('/actionplan/competencyModel/queryCompetencyModelInfo', {parentId:'0'})
        .then((res, total, code, data) => {
          console.log('queryCompetencyModelInfo')
          console.log(data)
          // name 名字
          // id: "2",
          this.parentALl = data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 查询
    getDataListMerge(){
      this.page = 1
      this.getDataList()
    },
    // 重置
    again(){
      this.dataForm.jobId = ''
      this.dataForm.parentId = ''
      this.dataForm.childId = ''
      this.dataForm.required = ''
      this.dataForm.courseCodeName = ''
      this.dataForm.importance = ''
      this.dataForm.isAffects = ''
      this.page = 1
      this.getDataList()
    },
    // 删除
    deleteAbility(row){
      this.$confirm(this.$t('prompt.info', {'handle': this.$t('delete')}), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel')
      }).then(() => {
        //TODO 执行删除接口
        this.$request
          .post('/actionplan/competencyToCourse/deleteCompetencyToCourse', {id:row.id})
          .then((res, total, code, data) => {
            console.log('deleteCompetencyToCourse')
            console.log(data)
            if(data.code === 1){
              this.$message.warning("删除成功")
              this.getDataList()
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 跳转编辑页面
    sendAbilityEdit(row){
      console.log('sendAbilityEdit')
      console.log(row)
      this.$router.push({
        name: 'acdc-courseAbility-courseAbilityEdit',
        query: {
          id: row.id
        }
      })
      this.$eventHub.$emit('showCourseAbilityEdit','')
    },
    // 能力项改值触发
    parentAllChange(){
      console.log('parentAllChange')
      console.log(this.dataForm.parentId)
      // 重置当前子能力项的值
      this.parentChildALl = []
      this.dataForm.childId = ''
      if(this.dataForm.parentId !== '' && this.dataForm.parentId !== undefined && this.dataForm.parentId !== null){
        this.$request
          .get('/actionplan/competencyModel/queryCompetencyModelInfo', {parentId:this.dataForm.parentId})
          .then((res, total, code, data) => {
            console.log('queryCompetencyModelInfo')
            console.log(data)
            // name 名字
            // id: "2",
            this.parentChildALl = data.data
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    // 新增课程能力项关系
    addCourseAbility(){
      this.$router.push({
        name: 'acdc-courseAbility-courseAbilityEdit',
        params: {
        }
      })
      this.$eventHub.$emit('showCourseAbilityAdd','')
    },
    // 分页, 每页条数
    pageSizeChangeHandle (val) {
      this.page = 1
      this.limit = val
      this.getDataList()
    },
    // 分页, 当前页
    pageCurrentChangeHandle (val) {
      this.page = val
      this.getDataList()
    },
  }
}
</script>
<style lang="scss" scoped>
@import "../../../css/pkg-styles.css";

.aui-wrapper .el-date-editor .el-range-separator {
  width: 30px;
}

.jieshu .el-form-item__content {
  width: 94.5%;
}

.kaishi .el-form-item__content {
  width: 111%;
}

.el-row {
  margin-bottom: 0px;
}

#container {
  display: -webkit-flex;
}

.el-date-editor.el-input {
  width: 150px;
}

.search-item {
  width: 94% !important;
  min-width: 290px;
}

.search {
  height: 50px;
}

.wrapper-div {
  .el-dialog__title {
    text-align: center;
    display: block;
  }
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

 .search-item .el-form-item__content {
  margin-left: 96px !important;
}

.course-ability-form{
  .el-col-7{
    padding-right: 0px !important;
  }
  .el-form-item{
    width: 100% !important;
  }
  .form-right{
    padding-right: 20px !important;
  }
}
</style>
